module.exports = __webpack_public_path__ + "static/ccsd.13e0a056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/ccsd.png
// module id = 2214
// module chunks = 61762850755587